import { render, staticRenderFns } from "./CreateCapitalProduct.vue?vue&type=template&id=8945da44&scoped=true"
import script from "./CreateCapitalProduct.vue?vue&type=script&lang=js"
export * from "./CreateCapitalProduct.vue?vue&type=script&lang=js"
import style0 from "./CreateCapitalProduct.vue?vue&type=style&index=0&id=8945da44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8945da44",
  null
  
)

export default component.exports